import { RespondentType } from '../models/questions';
import { CheckoutState } from '../state';
import { isEventbriteTLDInDevOrQAEnv } from '../utils/browser';
import { getEnablePaymentConstraintsInNewCreate, isEventbriteTLD } from './app';
import { isExpressApplePayEnabled } from './applePay';
import {
    getHasPromoCode,
    getIsFreeEvent,
    getIsReservedSeating,
    getSurveyType,
    hasSpecialInstructions,
    isDonation,
    isWaitlistEnabled,
} from './event';
import { isExpressGooglePayEnabled } from './googlePay';
import { isExpressPaypalEnabled } from './paypal';
import { getHasAddonsTicketsAvailable } from './tickets';
import { getNamespaceValue } from './utils/selector';

export const isApplePayElegible = (state: CheckoutState) =>
    isApplePayAvailableAsExpressPaymentMethod(state) &&
    !getIsFreeEvent(state) &&
    !hasPrepaymentQuestions(state) &&
    !getHasPromoCode(state) &&
    !getIsReservedSeating(state) &&
    !isDonation(state) &&
    !getHasAddonsTicketsAvailable(state) &&
    (isEventbriteTLD(state) || isEventbriteTLDInDevOrQAEnv());

export const areExpressCheckoutConditionsLoaded = (state: CheckoutState) =>
    !!getNamespaceValue(state.expressCheckout, 'expressCheckoutConditions');

export const hasCannedQuestions = (state: CheckoutState) =>
    getNamespaceValue(
        state.expressCheckout,
        'expressCheckoutConditions.hasCannedQuestions',
        true,
    );

export const hasCustomQuestions = (state: CheckoutState) =>
    getNamespaceValue(
        state.expressCheckout,
        'expressCheckoutConditions.hasCustomQuestions',
        true,
    );

export const hasPrepaymentQuestions = (state: CheckoutState) =>
    getNamespaceValue(
        state.expressCheckout,
        'expressCheckoutConditions.hasPrepaymentQuestions',
        true,
    );

export const isApplePayAvailableAsExpressPaymentMethod = (
    state: CheckoutState,
) =>
    getNamespaceValue(
        state.expressCheckout,
        'expressCheckoutConditions.hasApplePay',
        false,
    );

export const isPaypalAvailableAsExpressPaymentMethod = (state: CheckoutState) =>
    getNamespaceValue(
        state.expressCheckout,
        'expressCheckoutConditions.hasPaypal',
        false,
    );

export const isGooglePayAvailableAsExpressPaymentMethod = (
    state: CheckoutState,
) =>
    getNamespaceValue(
        state.expressCheckout,
        'expressCheckoutConditions.hasGooglePay',
        false,
    );

export const hasQuestions = (state: CheckoutState) =>
    hasCannedQuestions(state) || hasCustomQuestions(state);

export const areSyncExpressCheckoutEligibleCommonRulesMet = (
    state: CheckoutState,
) =>
    !getEnablePaymentConstraintsInNewCreate(state) &&
    !getIsFreeEvent(state) &&
    !getIsReservedSeating(state) &&
    !hasSpecialInstructions(state) &&
    !isWaitlistEnabled(state) &&
    (getSurveyType(state) === RespondentType.buyer ||
        getSurveyType(state) === RespondentType.direct);

export const areAsyncExpressCheckoutEligibleCommonRulesMet = (
    state: CheckoutState,
) => !hasPrepaymentQuestions(state);

export const isExpressCheckoutEnabled = (state: CheckoutState) =>
    isExpressApplePayEnabled(state) ||
    isExpressPaypalEnabled(state) ||
    isExpressGooglePayEnabled(state);
